<template xmlns="http://www.w3.org/1999/html">
    <div class="login">
        <div class="content">
            <div class="content-layer"></div>
            <!--            <div class="title">-->
            <!--                <h2 style="max-width: 600px;">E-LICENSE</h2>-->
            <!--                <p>Тусгай зөвшөөрлийн цахим систем</p>-->
            <!--            </div>-->

            <div class="header">
                <div class="logo">
                    <div class="title">
                        <h2
                            style="
                                max-width: 600px;
                                margin-bottom: 10px !important;
                            "
                        >
                            Eazy
                        </h2>
                        <p>Суртчилгаа үзээд мөнгө ол</p>
                    </div>
                </div>

                <ul class="menu">
                    <li>
                        <a href="javascript:void(0)" @click="showInstructModal">
                            Холбоо барих
                        </a>
                    </li>

                    <li>
                        <a href="/contact" target="_blank"> Бидний тухай </a>
                    </li>
                </ul>
            </div>
            <div class="content-body">
                <div class="lottie">
                    <lottie-animation path="assets/admin/login-bg.json" />
                </div>
            </div>

            <div class="footer">
                <h3>Манай платформ</h3>
                <hooper :settings="hooperSettings">
                    <slide>
                        <div class="footer-item">
                            <a>
                                <img
                                    class="svg-icon"
                                    src="/assets/icons/iconsax/global.svg"
                                    alt=""
                                />
                                <span>Найдвартай </span>
                            </a>
                        </div>
                    </slide>
                    <slide>
                        <div class="footer-item">
                            <a>
                                <img
                                    class="svg-icon"
                                    src="/assets/icons/iconsax/house.svg"
                                    alt=""
                                />
                                <span>Уян хатан нөхцөлтэй</span>
                            </a>
                        </div>
                    </slide>

                    <hooper-pagination slot="hooper-addons"></hooper-pagination>
                </hooper>
            </div>
        </div>

        <div class="auth">
            <div class="form-wrap">
                <router-view></router-view>
                <div class="copyright" v-html="copyright"></div>
            </div>
        </div>

        <v-modal
            name="faq-modal"
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :draggable="false"
            height="90%"
            width="70%"
        >
            <div class="d-modal">
                <div class="modal-header">
                    <h2 class="title">dd</h2>
                    <a
                        href="javascript:void(0)"
                        @click="$modal.hide('faq-modal')"
                        class="close"
                    >
                        <Icon type="ios-close" />
                    </a>
                </div>
                <div class="modal-body np">
                    <Spin v-if="isLoading" fix></Spin>
                    <Collapse simple style="text-align: left">
                        <Panel
                            v-for="item in faqs"
                            :key="item.index"
                            :name="item.index"
                        >
                            {{ item.title }}
                            <p slot="content">
                                <span v-html="item.content"></span>
                            </p>
                        </Panel>
                    </Collapse>
                </div>
            </div>
        </v-modal>

        <v-modal
            name="instruct-modal"
            :pivot-y="0.5"
            :adaptive="true"
            :reset="true"
            :draggable="false"
            height="90%"
            width="70%"
        >
            <div class="d-modal">
                <div class="modal-header">
                    <h2 class="title">title</h2>
                    <a
                        href="javascript:void(0)"
                        @click="$modal.hide('instruct-modal')"
                        class="close"
                    >
                        <Icon type="ios-close" />
                    </a>
                </div>
                <div class="modal-body np">
                    <p v-if="help" v-html="help.body"></p>
                </div>
            </div>
        </v-modal>
    </div>
</template>

<script>
import Vue from "vue";
import iView from "iview";
import vModal from "vue-js-modal";
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
import InlineSvg from "vue-inline-svg";
import {
    Hooper,
    Slide,
    Pagination as HooperPagination,
    Navigation as HooperNavigation,
} from "hooper";
import { loadLanguageAsync } from "../admin/locale";

Vue.use(iView);
Vue.use(vModal, { componentName: "v-modal" });

export default {
    components: {
        LottieAnimation,
        Hooper,
        Slide,
        HooperPagination,
        HooperNavigation,
        InlineSvg,
    },

    data() {
        return {
            isLoading: false,
            loading: false,
            isSuccess: false,
            isError: false,
            credentials: {
                login: null,
                password: null,
            },
            copyright: window.lambda.copyright,
            windowsd: window.lambda.windowslink,
            androidd: window.lambda.androidlink,
            languages: window.lambda.languages,
            selectedLang: "mn_MN",
            lambda: window.lambda,
            faqs: [],
            help: null,
            hooperSettings: {
                itemsToShow: 6,
                breakpoints: {
                    800: {
                        centerMode: false,
                        itemsToShow: 2,
                    },
                    1000: {
                        itemsToShow: 3,
                        pagination: "fraction",
                    },
                    1300: {
                        itemsToShow: 5,
                        pagination: "fraction",
                    },
                    1600: {
                        itemsToShow: 6,
                        pagination: "fraction",
                    },
                },
            },
        };
    },

    mounted() {},
    created() {},
    methods: {
        switchLanguage(val) {
            console.log("swutch", val);
            this.selectedLang = val;
            loadLanguageAsync(val);
        },
        showFaqModal(row) {
            this.isLoading = false;
            if (this.faqs.length == 0) {
                this.getFaqs();
            }
            this.$modal.show("faq-modal");
        },

        showInstructModal(row) {
            if (this.faqs.length == 0) {
                this.getFaqs();
            }
            this.$modal.show("instruct-modal");
        },

        showDetail(item) {
            this.currentNews = item;
            this.isList = false;
        },

        goBack() {
            this.isList = true;
        },
    },
};
</script>

<style lang="scss">
@import "./style";
</style>
